import React, { useState } from 'react'
import Container from 'react-bootstrap/Container';
import Table from 'react-bootstrap/Table';
import { Button } from 'react-bootstrap';
import Row from 'react-bootstrap/Row';
import { MdDelete } from "react-icons/md";
import { Link } from 'react-router-dom';
import { FaGear } from 'react-icons/fa6';
import AsignarUsuario from './AsignarUsuario';

const TableHeader = (props) => {
  return (

    <thead>
      <tr>
        <th style={{width:'20%'}}>Area N2</th>
        <th className='d-none d-sm-table-cell' style={{width:'40%'}}>Descripción área N2</th>
        <th className='d-none d-sm-table-cell' style={{width:'2%'}}>Quitar</th>
        <th className='d-none d-sm-table-cell' style={{width:'2%'}}>Config</th>
        <th className='d-none d-sm-table-cell' style={{width:'10%'}}>Juez</th>
      </tr>
    </thead>
  )
}

const TableBody = (props) => {
  
  if (props.listOfAreasN2) {
    
    const rows = props.listOfAreasN2.map((row, index) => { 

      return (      
        <tr key={index}>        
          <td>  
            {row["arean2"].nombrearea}
          </td>
          <td className='d-none d-sm-table-cell'>  
            {row["arean2"].descripcionarea}
          </td>  
          <td>
            <Button variant="secondary"><MdDelete /></Button>  
          </td> 
          <td>
            <Button variant="secondary">
              <Link
                to={`/editorganigramaposiciones/${row.childid}/${row.id}`}
                  //search: "?sort=name",
                  //hash: "#the-hash",
                  
                  state= {{
                    organigrama: props.organigrama
                  }}
                
              ><FaGear size={15} color='white'/>
              </Link>                
              {/**
              <Link to = {`/editorganigramaposiciones/${row.childid}/${row.id}`}><FaGear size={15} color='white'/></Link>      
              */}
            </Button>          
          </td>        
          <td>
            {/*{row.user?row.user.primerapellido + ", " + row.user.primernombre:null}  */}

            <AsignarUsuario 
              id={row.id} 
              organigramaareasid={row.id} 
              area={row.arean2}
              user={row.user}
            />              
          </td>                                           
        </tr>
      )
    })
    return (
      <tbody>
        {rows}
      </tbody>
    )  
  }
  else {
    return null;
  }
}
const CompetenciaAreasN2List = (props) => {        
  //console.log(props);
  return (
      <>
      <Container>
        <Row>
          <Table style={{verticalAlign:"baseline"}} striped bordered hover size="sm">
            <TableHeader mode={props.mode}/>
            <TableBody 
              mode={props.mode} 
              onSelected={props.onSelected} 
              listOfAreasN2={props.listOfAreasN2} 
              organigrama={props.organigrama} 
            />
          </Table>
        </Row>
        <hr/>
      </Container>
      </>
    );
}

export default CompetenciaAreasN2List;